import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import ConfirmationModal from '../common/ConfirmationModal/ConfirmationModal';
import { useStudentSubmissionDispatch } from './StudentSubmissionPageContext';

const FileUploadConfirmationModal = ({ onConfirm }) => {
  const { t } = useTranslation();
  const dispatch = useStudentSubmissionDispatch();

  return (
    <div data-testid="confirmation-modal">
      <ConfirmationModal
        lang="en"
        loading={false}
        onClose={() => dispatch({ type: 'closeFileUploadConfirmationModal' })}
        onConfirm={() => {
          dispatch({ type: 'closeFileUploadConfirmationModal' });
          onConfirm();
        }}
        title={t('Confirm')}
        buttonTextConfirm={t('Replace')}
        buttonTextCancel={t('Cancel')}
      >
        <span>
          {t(
            'Are you sure you want to replace the file submission with a new file?',
          )}
        </span>
      </ConfirmationModal>
    </div>
  );
};

FileUploadConfirmationModal.propTypes = {
  onConfirm: PropTypes.func.isRequired,
};

export default FileUploadConfirmationModal;
